export default {
	computed: {
		delayedLoginState() {
			return this.$store.getters.isLoggedIn
		}
	},
	watch: {
		delayedLoginState() {
			if (window.sessionStorage && this.delayedLoginState) {
				try {
					const callMethodJSON = sessionStorage.getItem('callMethod')
					const callMethod = callMethodJSON ? JSON.parse(callMethodJSON) : null

					if (callMethod && callMethod.componentName && callMethod.methodName && callMethod.componentName === this.$options.name) {
						sessionStorage.removeItem('callMethod')
						this[callMethod.methodName]()
					}
				} catch(e) {
					sessionStorage.removeItem('callMethod')
				}
			}
		}
	},
	methods: {
		callMethodAfterLogin(methodName) {
			if (window.sessionStorage) {
				sessionStorage.setItem('callMethod', JSON.stringify({ componentName: this.$options.name, methodName: methodName }))
			}
		}
	}
}
